export const ENVIRONMENT = {
  DEV: 'development',
  PREV: 'preview',
  PROD: 'production',
  FEATURE: 'feature',
}
